import React from "react";
import { Modal, Button } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTrashAlt } from "@fortawesome/free-solid-svg-icons";

interface Props {
  show: boolean;
 company: any;
  onClose: () => void;
  onConfirm: () => void;
}

export default function DeleteCompanyModal({
  show,
  company,
  onClose,
  onConfirm,
}: Props) {
  return (
    <Modal centered show={show} onHide={onClose}>
      {/* HEADER */}
      <Modal.Header closeButton className="border-0 pb-0">
        <Modal.Title className="fw-bold text-danger d-flex align-items-center gap-2">
          <FontAwesomeIcon icon={faTrashAlt} />
          Delete Company
        </Modal.Title>
      </Modal.Header>

      {/* BODY */}
      <Modal.Body className="text-center pt-2">
        <p className="fs-5 mb-3">
          Are you sure you want to delete this Company?
        </p>

        {/*  */}
        {company && (
          <div
            className="p-3 mb-3"
            style={{
              background: "#f8f9fa",
              borderRadius: "10px",
              border: "1px solid #eee",
            }}
          >
            <div className="fw-semibold fs-5">{company.name}</div>
            <div className="text-muted">{company.email}</div>
          </div>
        )}

        <div className="text-danger small fw-semibold">
          This action cannot be undone.
        </div>
      </Modal.Body>

      {/* FOOTER */}
      <Modal.Footer className="border-0 pt-0">
        <Button variant="secondary" onClick={onClose}>
          Cancel
        </Button>

        <Button variant="danger" onClick={onConfirm}>
          <FontAwesomeIcon icon={faTrashAlt} className="me-2" />
          Delete
        </Button>
      </Modal.Footer>
    </Modal>
  );
}
